import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "activity-person" }

import { ref, withDefaults, reactive, computed } from 'vue';
import { storeToRefs } from 'pinia';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  createDialog,
  useInputColumn,
  useSelectColumn,
  BaseRadioGroup,
  BaseRadio,
  useCreateModal,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import BatchAddActivityPerson from './batch-add-activity-person.vue';
import {
  activityPeopleList,
  addActivityPeople,
  delActivityPeople,
  activityPeopleListExport
} from '../data-source/apis';
import { formatter, translator } from '@/utils';
import BaseInsert from './base-insert.vue';
import { phoneSearch } from '../fields/searchs';
import { validatorPhone } from '@/utils/validator';
import {
  SETTLEMENT_ACTIVITY_STATUS,
  SETTLED_STATUS,
  ENABLED_STATUS
} from '../constants';
import appStore from '@/store';
import { getUnqualifiedRowConfig } from '@/utils/unqualified';


export default /*#__PURE__*/_defineComponent({
  __name: 'activity-person',
  props: {
    disabled: { type: Boolean },
    activityId: { default: null },
    projectId: { default: null },
    submitStatus: { default: null }
  },
  setup(__props: any) {

const props = __props;

const xrkTableRef = ref<XrkTableRef>();
const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};
// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
const isAsp = computed(() => defaultUserFnCode.value === 2);

const baseNameInsertRef = ref();
const basePhoneInsertRef = ref();
const basePriceInsertRef = ref();
const importType = reactive({
  value: 1
});

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      prop: 'userName',
      type: 'input',
      label: '项目参与人',
      config: {
        placeholder: '项目参与人'
      }
    }),
    phoneSearch,
    useSelectColumn({
      prop: 'settlementStatus',
      label: '结算状态',
      config: {
        placeholder: '请选择结算状态',
        options: SETTLEMENT_ACTIVITY_STATUS
      }
    })
  ],
  otherComponents: [
    isAsp.value && {
      render() {
        return (
          <>
            <BaseButton
              click={async () => {
                await activityPeopleListExport({
                  projectId: props.projectId,
                  activityId: props.activityId,
                  ...xrkTableRef.value.getSearchValue()
                });
              }}
              type="primary2"
            >
              下载导出
            </BaseButton>
            <BaseButton
              disabled={props.submitStatus || props.disabled}
              type="primary2"
              onClick={() => {
                createDialog({
                  width: 650,
                  title: '请选择导入方式',
                  showClose: true,
                  contentRender: () => {
                    return (
                      <>
                        <div style="padding:20px">
                          <BaseRadioGroup v-model={importType.value}>
                            <BaseRadio value={1}>
                              按当前人员名单执行
                              <div style="color: #ff3535">
                                不存在于当前导入表单的自然人将看不到此项目
                              </div>
                            </BaseRadio>
                            <BaseRadio style="margin-top:20px" value={2}>
                              新增当前人员名单
                              <div style="color: #ff3535">
                                当前导入表单内的自然人将新增到项目人员列表，项目人员列表内已存在的自然人可继续执行
                              </div>
                            </BaseRadio>
                          </BaseRadioGroup>
                        </div>
                      </>
                    );
                  },
                  beforeConfirm: async done => {
                    useCreateModal(BatchAddActivityPerson, {
                      activityId: props.activityId,
                      importType: importType.value,
                      onSuccess: () => {
                        onRefreshTabel();
                      }
                    });
                    done();
                  }
                });
              }}
            >
              导入
            </BaseButton>
            <BaseButton
              disabled={props.submitStatus || props.disabled}
              type="primary2"
              onClick={() => {
                createDialog({
                  width: 350,
                  title: '添加人员',
                  showClose: true,
                  contentRender: () => {
                    return (
                      <>
                        <div style="padding:20px">
                          <BaseInsert
                            labelPosition={'top'}
                            ruleValidator={(
                              rule: any,
                              value: any,
                              callback: any
                            ) => {
                              if (value === '') {
                                return callback(new Error('请输入姓名'));
                              } else {
                                callback();
                              }
                            }}
                            label={'姓名'}
                            placeholder={'请输入姓名'}
                            maxlength={50}
                            type="text"
                            ref={baseNameInsertRef}
                            inputTextReplace={true}
                            inputTexts={['汉字', '·']}
                          ></BaseInsert>
                          <BaseInsert
                            labelPosition={'top'}
                            ruleValidator={validatorPhone}
                            label={'手机号'}
                            placeholder={'请输入手机号'}
                            type="tel"
                            ref={basePhoneInsertRef}
                          ></BaseInsert>
                          <BaseInsert
                            labelPosition={'top'}
                            ruleValidator={(
                              rule: any,
                              value: any,
                              callback: any
                            ) => {
                              if (value === '') {
                                return callback(new Error('请输入结算金额'));
                              } else if (+value > 90000 || +value < 1) {
                                return callback(
                                  new Error('请输入 1~90000 之间金额')
                                );
                              } else {
                                callback();
                              }
                            }}
                            maxlength={50}
                            label={'结算金额'}
                            placeholder={'请输入结算金额'}
                            type="number"
                            ref={basePriceInsertRef}
                          ></BaseInsert>
                        </div>
                      </>
                    );
                  },
                  beforeConfirm: async done => {
                    const { data: activityPeopleName } =
                      await baseNameInsertRef.value.getFormData();
                    const { data: phone } =
                      await basePhoneInsertRef.value.getFormData();
                    const { data: price } =
                      await basePriceInsertRef.value.getFormData();
                    await addActivityPeople({
                      activityId: props.activityId,
                      activityPeopleName: activityPeopleName,
                      phone: phone,
                      price: translator.yuan2fen(+price)
                    });
                    XrkMessage.success('添加成功');
                    onRefreshTabel();
                    done();
                  }
                });
              }}
            >
              单独添加
            </BaseButton>
          </>
        );
      }
    }
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '姓名',
      prop: 'userName'
    }),
    useTableColumn({
      label: '手机号',
      prop: 'phone'
    }),
    useTableColumn({
      label: '状态',
      prop: 'enabled',
      formatter: ({ cellValue }) => ENABLED_STATUS[cellValue]?.label || '-'
    }),
    useTableColumn({
      label: '入驻状态',
      prop: 'status',
      formatter: ({ cellValue }) => SETTLED_STATUS[cellValue]?.label || '-'
    }),
    useTableColumn({
      label: '结算金额',
      prop: 'price',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue, '元')
    }),
    useTableColumn({
      label: '结算状态',
      prop: 'settlementStatus',
      formatter: ({ cellValue }) =>
        SETTLEMENT_ACTIVITY_STATUS[cellValue]?.label || '-'
    }),
    isAsp.value &&
      useTableColumn({
        align: 'center',
        width: 110,
        label: '操作',
        render({ row }) {
          return (
            <>
              <div>
                <BaseButton
                  disabled={props.disabled}
                  onClick={async () => {
                    await XrkMessageBox.confirm('是否确认删除？', '提示', {
                      confirmButtonText: '确认',
                      cancelButtonText: '取消'
                    });
                    await delActivityPeople({
                      activityId: props.activityId,
                      projectId: props.projectId,
                      userId: row.userId
                    });
                    XrkMessage.success('删除成功');
                    onRefreshTabel();
                  }}
                  type="text"
                >
                  删除
                </BaseButton>
              </div>
            </>
          );
        }
      })
  ].filter(Boolean),
  baseConfig: {
    rowClassName({ row, rowIndex }) {
      return getUnqualifiedRowConfig({
        row: row,
        rowIndex: rowIndex,
        isNotUnqualified: row?.superviseStatus === 1
      });
    }
  }
});

const getListAjax = async params => {
  const data = await activityPeopleList({
    ...params,
    projectId: props.projectId,
    activityId: props.activityId
  });
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})